/**
 * useExpedienteAuditLog
 * Historial de accesos al expediente con paginación estándar (page/page_size).
 */
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getExpedienteAuditLog } from '@/services/expedientes.service';
import { PARTNER_ID } from '@/constants';

const DEFAULT_PAGE_SIZE = 25;

export function useExpedienteAuditLog(directoryId: string | undefined, enabled: boolean) {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);

  const query = useQuery({
    queryKey: ['expedientes', 'audit-log', directoryId, PARTNER_ID, page, pageSize],
    queryFn: () => getExpedienteAuditLog(directoryId!, PARTNER_ID, page, pageSize),
    enabled: Boolean(directoryId) && enabled,
  });

  return {
    items: query.data?.data.items ?? [],
    pagination: query.data?.data.pagination,
    isLoading: query.isLoading,
    isError: query.isError,
    page,
    pageSize,
    setPage,
    setPageSize,
    refetch: query.refetch,
  };
}
